import { render } from "./cursed-relics.vue?vue&type=template&id=3261156f&scoped=true"
import script from "./cursed-relics.vue?vue&type=script&lang=js"
export * from "./cursed-relics.vue?vue&type=script&lang=js"

import "./cursed-relics.vue?vue&type=style&index=0&id=3261156f&scoped=true&lang=css"
import "./cursed-relics.vue?vue&type=style&index=1&id=3261156f&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3261156f"]])

export default __exports__